<template >
  <vs-chip class="status-chip"  :color="getOrderStatusColor(params.data.meta.status)">
    {{ params.data.meta.status }}
  </vs-chip>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  computed: {
    chipColor () {
      return (value) => {
        if (value === 'active') return 'success'
        else if (value === 'blocked') return 'danger'
        else if (value === 'deactivated') return 'warning'
        else return 'primary'
      }
    }
  },
  methods: {
    getOrderStatusColor (status) {
      console.log(status);
      if (status === 'Nueva')   return 'warning'
      if (status === 'Solicitud')   return 'warning'
      if (status === 'Completado') return 'success'
      if (status === 'Terminada')  return 'primary'
      if (status === 'Anulada')  return 'danger'
      return 'primary'
    },
  }
}
</script>

<style scoped>
.status-chip{
    height: 10%;
    margin-top: 10px;
}
</style>